import React, {useEffect, useState } from "react";
import { getAllAdmins } from "../../utils/helper";
import { Link } from "react-router-dom/cjs/react-router-dom";
import Loader from "../../utils/Loader";
import { useHistory } from "react-router-dom";


export default function Employees() {
    const [employees, setEmployees] = useState(null);
    const history = useHistory();

    useEffect(() => {
        getAllAdmins()
            .then((res) => { 
                setEmployees(res.data.data);  
            })
            .catch((err) => { 
                console.log(err.response)
            });
    }, []);

    
    const navigateById = (path, id) => {
        history.push(`${path}/${id}/view`);
    };

    return (
        <>
            <div className="spur-card-menu"><Link to="/hiring" className="pull-right btn topbtn btn-primary">HIRE NEW EMPLOYEE</Link></div>
            
            <h1 className="dash-title">Employees Management</h1>

            <div className="row dash-row">
                
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">Employees</div>
                        </div>
                        <div className="card-body">
                            <div className="my_profile">
                                {employees && employees ? 
                                    <div className="table-responsive">
                                        <table className="table text-left text-caps table-bordered" id="myTable">
                                            <thead><tr><th>SN</th><th>Name</th><th>Job Title</th><th>Status</th><th>Attendance</th><th>Date Joined</th>
                                            <th>Last Active</th>
                                            <th>View</th></tr></thead>
                                            <tbody>
                                                {employees && employees.map((staff, index) => 
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{staff.first_name && staff.first_name} {staff.last_name && staff.last_name}</td>
                                                        <td>{staff.job_title && staff.job_title?.name}</td>
                                                        <td>{staff.active ? <span className="badge badge-success">ACTIVE</span> : 
                                                        <span className="badge badge-danger">DEACTIVATED</span> }</td>
                                                        <td>{staff.attendanceStatus === "clocked in" ? 
                                                        <span className="badge badge-success">{staff.attendanceStatus}</span> : 
                                                        <span className="badge badge-warning">{staff.attendanceStatus}</span>}</td>
                                                        <td>{staff.hire_month && staff.hire_month} {" "} {staff.hire_date && staff.hire_date}</td>
                                                        <td>{staff.lastActive && staff.lastActive}</td>
                                                        <td>
                                                            <button 
                                                                onClick={() => navigateById("/employee", staff._id)} 
                                                                className='btn btn-preview'
                                                            >
                                                                    <i className="fa fa-eye"></i> View
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                </div> : <Loader /> }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
